import supabase from '../supabase/supabase';
import { fetchAllPages } from './paginatedFetch';

export const reviewService = {
  async getAll(options = {}) {
    return fetchAllPages(
      () => supabase.from('reviews').select('*').order('created_at', { ascending: false }),
      { ...options, label: 'Bewertungen' },
    );
  },

  async create(data) {
    const { data: newReview, error } = await supabase.from('reviews').insert([data]).select().single();
    if (error) throw error;
    return newReview;
  },
};
